import { formatCurrency } from '../../lib/format'
import type { PlanCompositionRow } from '../../domain/plans/planCompositionRows'

export function PlanCompositionTable({
  rows,
  completedCount,
  totalCount,
  totalAmount,
  maxHeightClassName = 'max-h-72',
}: {
  rows: PlanCompositionRow[]
  completedCount?: number
  totalCount?: number
  totalAmount?: number | null
  maxHeightClassName?: string
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className={`overflow-y-auto ${maxHeightClassName}`}>
        <table className="min-w-full text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Услуга</th>
              <th className="px-3 py-3 w-16">Зуб</th>
              <th className="px-3 py-3 w-14">Кол.</th>
              <th className="px-3 py-3 w-28 text-right">Цена</th>
              <th className="px-4 py-3 w-28 text-right">Сумма</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-slate-500">
                  Состав плана пока недоступен.
                </td>
              </tr>
            ) : rows.map((row) => (
              <tr key={row.id} className="hover:bg-slate-50/80">
                <td className="px-4 py-3 text-slate-800">{row.serviceName}</td>
                <td className="px-3 py-3 text-slate-600">{row.toothNumber ?? '—'}</td>
                <td className="px-3 py-3 text-slate-600">{row.quantity}</td>
                <td className="px-3 py-3 text-right text-slate-700">{formatCurrency(row.unitPrice)}</td>
                <td className="px-4 py-3 text-right font-medium text-slate-900">{formatCurrency(row.totalPrice)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between gap-3 border-t border-slate-100 bg-slate-50 px-4 py-3 text-sm">
        <span className="text-slate-500">
          {completedCount ?? 0} / {totalCount ?? rows.length} {totalCount === 1 ? 'услуга' : 'услуг'}
        </span>
        {totalAmount != null ? (
          <strong className="text-slate-900">Итого: {formatCurrency(totalAmount)}</strong>
        ) : null}
      </div>
    </div>
  )
}
